package one.primehealth.app

import co.touchlab.kermit.Logger

interface UserData {
    suspend fun clear()
}

class UserDataManager(
    private val userData: List<UserData>,
) {
    suspend fun clear() {
        userData.forEach {
            try {
                it.clear()
            } catch (e: Exception) {
                Logger.e("Failed to clear user data", e)
            }
        }
    }
}